import { Drawer, DrawerProps } from "antd";

export const CustomDrawer: React.FC<DrawerProps> = ({ ...props }) => {
  return (
    <Drawer
      width="100%"
      push={false}
      mask={false}
      {...props}
      style={{ position: "absolute", height: "100%" }}
    />
  );
};
